import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/supplier-tour-line-set',
      name: 'admin-supplier-tour-line-set',
      component: () => import(/* webpackChunkName: "page-admin-supplier-management-suppiler-tour-line-set" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "线路设置"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "供应商管理"
                                        },
                                        {
                                                  name: "供应商列表"
                                        },
                                        {
                                                  name: "线路设置"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
